// Полифилы для старых браузеров (Safari < 15.4, Chrome < 90 и т.п.).
// БЕЗ этой строки бандл падает с "Object.hasOwn is not a function" → белый экран.
// ДОЛЖНО быть самым первым импортом — до любого кода приложения.
import 'core-js/stable';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // Отключаем StrictMode для совместимости с библиотеками drag-and-drop
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// SW отключён: снимаем все старые регистрации и чистим кэши (см. serviceWorkerRegistration.ts)
register();

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
